/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicServiceAccountMaintenance extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicServiceAccountMaintenance");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicServiceAccountMaintenance.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicServiceAccountMaintenance>): BackgroundJobPayloadForPeriodicServiceAccountMaintenance {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicServiceAccountMaintenance(), model);
        BackgroundJobPayloadForPeriodicServiceAccountMaintenance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicServiceAccountMaintenance>): BackgroundJobPayloadForPeriodicServiceAccountMaintenance {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicServiceAccountMaintenance.newInstance(<BackgroundJobPayloadForPeriodicServiceAccountMaintenance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicServiceAccountMaintenance) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicServiceAccountMaintenance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicServiceAccountMaintenance): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicServiceAccountMaintenance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
